import { useMemo } from 'react';
import { useGetCategoryTreeQuery } from '../components/global/CategoryTree/apiCategoryTree';
import { CategoryTreeNode, PartialExceptionExpanded } from '../lib/categories/categoryTypes';
import { categoryStringRoute } from '../lib/categories/categoriesLib';
import { ROOT_CATEGORY_ID } from '../components/global/_constants';
import { useTemplateOrCalculationWithValue } from './useTemplateOrCalculationWithValue';

export const useExceptions = (
  startingCategoryId: number = ROOT_CATEGORY_ID,
): PartialExceptionExpanded[] => {
  const templateOrCalculation = useTemplateOrCalculationWithValue();
  const { data: categories } = useGetCategoryTreeQuery(templateOrCalculation.value);

  return useMemo(() => {
    if (categories) {
      const e: PartialExceptionExpanded[] = [];

      const findExceptionCategories = (
        node: CategoryTreeNode | undefined,
        e: PartialExceptionExpanded[],
      ) => {
        if (node === undefined) return;
        const notHiddenExceptions = node.exceptions.filter(e => !e.hidden);
        if (notHiddenExceptions.length > 0) {
          e.push(
            ...notHiddenExceptions.map(e => ({
              ...e,
              category: node,
              titleFull: categoryStringRoute(node),
            })),
          );
        }

        node.children.forEach(child => {
          if (
            (categories[child]?.childExceptionCount ?? 0) > 0 ||
            (categories[child]?.exceptions.length ?? 0) > 0
          ) {
            findExceptionCategories(categories[child], e);
          }
        });
      };

      findExceptionCategories(categories[startingCategoryId], e);

      return e;
    }
    return [];
  }, [categories, startingCategoryId]);
};
